$(window).load(function() {
  // if ($('.homepage .section-tier-one #siteInfoBannerWidget').length) {
  //   let mc = $('.section-tier-one #siteInfoBannerWidget').clone();
  //   mc.attr('id', 'siteInfoBannerWidget-m');
  //   mc.removeClass('siteInfoBanner');
  //   mc.prependTo('.header-bottom-mobile');
  // }

  if ($(body).hasClass('siteInfoBannerOn')) {
    var sib = $('#siteInfoBannerWidget');
    var mnt = $('.mobile-nav-toggle');
    $(window).scroll(function() {
      if ($(window).scrollTop() > 47) {
        sib.addClass('sib-hide');
        mnt.addClass('mnt-scrolled');
      } else {
        sib.removeClass('sib-hide');
        mnt.removeClass('mnt-scrolled');        
      }
    });

  }


  // custom email signup functionality
  if ($('body').hasClass('homepage')) {
    function handleCustomEmailSignup() {
      let submitBtn = $('.custom-email-signup__submit');
      
      submitBtn.on('keypress click', function(e) {
        if (e.key === 'Enter' || e.type === 'click') {
          let val = $('.custom-email-signup__input').val();
          $('.footer .emailSignup .inputFieldTextbox').val(val);
          $('.footer .emailSignup .emailSubmitButton').click();
        }
      });
    }
    handleCustomEmailSignup();

  }



  // custome footer sitemap
  const mainNav = $('#mainNavigation');

  let customFooterNavData = [];
  mainNav.find('.group').each(function(i) {
    let group = $(this);
    let topLevelText = group.find('.showingNav').text();
    let topLevelURL = group.find('.showingNav').attr('href');
    let groupLinks = [];
    group.find('> .items > .item').each(function(i) {

      if (!$(this).hasClass('navClonedItem') && !$(this).hasClass('clonedFirstChild')) { 
        let linkText = $(this).find('> a').text();
        let linkURL = $(this).find('> a').attr('href');
        groupLinks.push(`<a href="${linkURL}">${linkText}</a>`);

        // subitems
        if ($(this).attr('aria-haspopup') == 'true') {
          let subItems = $(this).find('> .subitems > .item');
          subItems.each(function(t) {
            if (!$(this).hasClass('navClonedItem')) { 
              let linkText = $(this).find('> a').text();
              let linkURL = $(this).find('> a').attr('href');
              groupLinks.push(`<a href="${linkURL}">${linkText}</a>`);

              // sub subitems
              if ($(this).attr('aria-haspopup') == 'true') {
                let subSubItems = $(this).find('> .subitems > .item');
                subSubItems.each(function(t) {
                  if (!$(this).hasClass('navClonedItem')) { 
                    let linkText = $(this).find('> a').text();
                    let linkURL = $(this).find('> a').attr('href');
                    groupLinks.push(`<a href="${linkURL}">${linkText}</a>`);
                  }
                });
              }
            }
          });
        }
      }
    });
    customFooterNavData.push({
      topLevelText: topLevelText,
      topLevelURL: topLevelURL,
      links: groupLinks
    })
  });


  footerNavHTML = [];
  customFooterNavData.forEach(function(item) {
    let html = `
      <div class="footer-nav-col">
        <a href="${item.topLevelURL}" class="footer-nav-col__title">${item.topLevelText}</a>
        <div class="footer-nav-col__links">
          ${item.links.join('')}
        </div>
      </div>
    `;
    footerNavHTML.push(html);
  });

  $('.footer-top-inner').append(`<div class="footer-nav">${footerNavHTML.join('')}</div>`);

  
  // social network footer stuff
  const socialSidebar = $('.footer .socialNetworks')
  socialSidebar.appendTo($(`.footer-nav-col`).last());
  socialSidebar.css('display', 'flex');
  
  // clone social network sidebar
  const socialClone = $('.footer .socialNetworks').clone();
  socialClone.appendTo('.footer-bottom-inner__left');


  // Change mobile nav directions link
  const mobileNavFooter = $('.mobile-menu-footer-links');
  const mobileNavFooterLinks = $('.mobile-menu-footer-links a');

  mobileNavFooterLinks.each(function() {
    if ($(this).attr('href').includes('directions')) {
      $(this).text('Locations');
      $(this).attr('href', 'https://www.peoplesfcu.com/p/about/locations');
    }
  });

  // Add credit card login link to mobile nav
  const ccLoginLink = $('.h-login').attr('href');
  $(`<a href="${ccLoginLink}" target="_blank">Credit Card Login</a>`).prependTo(mobileNavFooter);


});

$(document).ready(function() {

  // prepend generalmessage to header
  if ($('body').hasClass('generalMessageOn')) {
    $('.generalmessage').prependTo('.header');
  }

  // custom header search field functionality
  function handleSearch() {
    const input = $('.customSearch__input');
    const value = input.val();
    if (value !== '') { 
      $('.searchBox .inputFieldTextbox').val(value);
      $('.searchBox .searchSubmitButton').click();
    } else {
      return false;
    }
  }

  $('.customSearch').on('click keypress', function(e) {
    e.preventDefault();
    if (e.key === 'Enter' || e.type === 'click') {
      let wrapper = $('.customSearch-wrapper');
      if (!wrapper.hasClass('search-active')) {
        wrapper.fadeOut('fast', function() {
          wrapper.addClass('search-active');
          wrapper.fadeIn('fast', function() {
            $('.customSearch__input').focus();
          });
        })
      } else {
        handleSearch();
      }
    }
  });
  $('.customSearch__close').on('click keypress', function(e) {
    const wrapper = $('.customSearch-wrapper');
    wrapper.fadeOut('fast', function() {
      wrapper.removeClass('search-active');
      wrapper.fadeIn('fast');
    });
  });

  // change footer email signup text
  const footerBIR = $('.footer-bottom-inner__right');
  footerBIR.find('.emailSignupText').text('Sign up for the Peoples Newsletter');
  footerBIR.find('.inputFieldTextbox').attr('value', '');
  footerBIR.find('.inputFieldTextbox').attr('placeholder', 'enter email');
  footerBIR.find('.emailSubmitButton').text('Subscribe');

  // change footer saffire logo
  $('.footer .saffire_logo').attr('src', `${FULLCLIENTTHEMEPATH}images/saffireFooter-logo.png`);
  $(`<img src="${FULLCLIENTTHEMEPATH}images/saffireFooter-logo-m.png" class="saffire_logo-m">`).insertAfter('.footer .saffire_logo');

});



$(document).ready(function() {

  if (('IntersectionObserver' in window) && $('body').hasClass('homepage')) {
      const mountains0 = $('.mountains-bg');
      const mountains1 = $('.mountains-bg-1');
      const mountains2 = $('.mountains-bg-2');
      const mountains3 = $('.mountains-bg-3');
      const mountains4 = $('.mountains-bg-4');

      function mountainParallax() {
        jQuery(window).trigger('resize').trigger('scroll');
    
        $(window).on('scroll', function() {
            let mountainsHeight =  mountains0.innerHeight();
            let mountainsTop = $('.mountains-bg').offset().top;
            let bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
            let distance = mountainsHeight - (bottom_of_screen - mountainsTop);
    
    
            if (distance > -1 && distance < (mountainsHeight + 250)) {
              let percentage = ((distance / mountainsHeight) * 100).toFixed();
              if (percentage < 0) {
                percentage = 0;
              }
    
              mountains1.css('transform', `translateY(${percentage / 16}%)`);
              mountains2.css('transform', `translateY(${percentage / 8}%)`);
              mountains3.css('transform', `translateY(${percentage / 4}%)`);
              mountains4.css('transform', `translateY(${percentage / 2}%)`);
    
            }
    
        });
      }


      mountains0.addClass('io-supported');
      mountainParallax();
  } else {
    return false;
  }




  // function mountainParallax() {
  //   const intersectionObserver = new IntersectionObserver((entries, observer) => {
  //     entries.forEach((entry) => {
  //       if (entry.isIntersecting) {
  //         // element is in viewport, do the stuff
  //         $(window).scroll(function() {
  //           console.log(entry)
  //         })
  //         // it's good to remove observer,
  //         // if you don't need it any more
  //         // observer.unobserve(entry.target);
  //       } else {
  //         console.log('bno')
  //       }
  //     });
  //   });
    
  //   // start observing your elements
  //   intersectionObserver.observe(document.querySelector('.mountains-bg'));
  // }


});


$(window).load(function() {

    // popup for external links
    const exitPopup = function(destinationURL) {
      const popupHTML = `
        <div id="exitModal">
          <div class="exitModal__content" tabindex="0">
            <h2>You are leaving the Peoples Credit Union website</h2>
            <p>You are leaving the Peoples Credit Union website to visit one of our preferred partner's websites. If you continue, a page will open in a new tab on your browser.</p>
            <div class="exitModal__content__button-container">
              <a href="javascript:void(0);" class="exitModal__cancel-btn button" aria-label="Cancel and return to current page">Cancel</a>
              <a href="javascript:void(0);" class="exitModal__continue-btn button" aria-label="You are leaving the Peoples Credit Union website to visit one of our preferred partner's websites. If you continue, a page will open in a new tab on your browser. Continue to ${destinationURL}?">Continue</a>
            </div>
          </div>
        </div>
      `;
  
      $('body').append(popupHTML);
      $('.exitModal__content').focus();
  
      $('#exitModal .exitModal__cancel-btn').on('click keydown', function(event) {
        if (event.key === 'Enter' || event.type === 'click') {
          $('#exitModal').fadeOut();
          $('#exitModal').remove();
        }
      });
  
      $('#exitModal .exitModal__continue-btn').on('click keydown', function(event) {
        if (event.key === 'Enter' || event.type === 'click') {
          window.open(destinationURL, '_blank');
          $('#exitModal').remove();
        }
      });
  
    };
  
    const allLinks = $('a[href]').map(function() {
      const hr = $(this).attr('href');
      if (!hr.includes('www.peoplesfcu.com') && !hr.includes('.pdf') && hr.includes('http')) {
        if ((hr !== 'https://www.netbranch.app.fiserv.com/pfcu/') && (hr !== 'https://accountcreate.fiservapps.com/App/AC_0124/App.aspx?AppID=11001') && (hr !== 'https://www.financial-net.com/peoplesfcu/lending/InternetLoans')) {
          $(this).removeAttr('target');
          return $(this);
        }
      }
    });
  
    allLinks.each(function() {
      const href = $(this).attr('href');
      $(this).on('click keydown', function(event) {
        if (event.key === 'Enter' || event.type === 'click') {
          event.preventDefault();
          exitPopup(href);
        }
      })
    });

});